import type { HtmlTransform } from '../formatMessage'

/**
 * Pre-markdown transform: restyle <div class="clause-suggestion"> blocks
 * into styled cards. These divs come from the contract chat API and must
 * be restyled before marked.parse() processes the content.
 *
 * No-op when no clause-suggestion divs exist (safe for any chat surface).
 */
export const clauseCards: HtmlTransform = (content) =>
  content.replace(
    /<div class="clause-suggestion"[^>]*>([\s\S]*?)<\/div>/g,
    '<div class="my-2 p-3 rounded-md bg-primary-light border border-primary/20 text-sm font-mono whitespace-pre-wrap">$1</div>',
  )
